/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
// @ts-ignore
import { Drawer, Summary } from '../../../eden/eden-drawer';

import { IProductSpecificationViewProps } from '@msdyn365-commerce-modules/product-specification/src/modules/product-specification/./product-specification';
import { Table, TdName, TdValue } from './product-specification.styled';

import { getProductSizeChartAsync } from '../../../actions/DataActionExtension.g';

const ProductSpecTable = (props: { specs: ProductSpecification[] }) => {
    return (
        <Table>
            {props.specs.map((spec: ProductSpecification) => (
                <tr className='scr'>
                    <TdName>{spec.Name}</TdName>
                    <TdValue>{spec.TextValue}</TdValue>
                </tr>
            ))}
        </Table>
    );
};

interface ProductSpecification {
    Name: string;
    TextValue: string;
}

const ProductSpecificationView: React.FC<IProductSpecificationViewProps> = props => {
    const [sizingChartCustom, setSizingChartCustom] = React.useState();
    const [currentSku, setCurrentSku] = React.useState();
    const [longDescriptionValue, setLongDescriptionValue] = React.useState<any>();
    const { ProductSpecification, ProductSpecificationTableProps, ProductSpecificationTableBodyProps } = props;
    const drawerSummaries = [];
    const sizingChartAsync = async () => {
        const ctx = { callerContext: props.context.actionContext };
        let sizingChartApi: any;
        sizingChartApi = await getProductSizeChartAsync(
            ctx,
            //@ts-ignore
            props.data.product.result.MasterProductId ? props.data.product.result.MasterProductId : props.data.product.result.RecordId,
            props.context.request.locale
        ).catch((err: any) => {
            console.log(err);
        });

        setSizingChartCustom(sizingChartApi);
    };

    let productSku: any;
    let productNum: any;

    React.useEffect(() => {
        //@ts-ignore
        if (props.data && props.data.product && props.data.product.result) {
            sizingChartAsync();
        }
    }, []);

    // @ts-ignore
    const productSpecificationData = props.data?.productSpecificationData?.result;
    const longDescription: string[] = productSpecificationData
        .filter((x: { ExtensionProperties: any[] }) =>
            x.ExtensionProperties.find(y => y.Key === 'AttributeType' && y.Value.IntegerValue === 1)
        )
        .map((z: ProductSpecification) => z.TextValue);

    if (!longDescriptionValue && longDescription) {
        setLongDescriptionValue(longDescription);
    }

    const sizingChart: string[] = productSpecificationData
        .filter((x: { ExtensionProperties: any[] }) =>
            x.ExtensionProperties.find(y => y.Key === 'AttributeType' && y.Value.IntegerValue === 2)
        )
        .map((z: ProductSpecification) => z.TextValue);

    const productSpec: ProductSpecification[] = productSpecificationData
        .filter((x: { ExtensionProperties: any[] }) =>
            x.ExtensionProperties.find(y => y.Key === 'AttributeType' && y.Value.IntegerValue === 4)
        )
        .map((z: ProductSpecification) => {
            return {
                Name: z.Name,
                TextValue: z.TextValue
            };
        });

    React.useEffect(() => {
        if (!productSku) {
            productSku = sessionStorage.getItem('productSku');
        }
        if (!productNum) {
            productNum = productSpec.filter((item: any) => {
                return item.Name === 'Item number';
            });
        }
        if (productNum && !productNum[0].TextValue.includes('PI') && currentSku !== productNum[0].TextValue) {
            const categoriesArray = window.sessionStorage.getItem('ProductCategory');
            const category = categoriesArray ? categoriesArray.split(',')[0] : '';
            //@ts-ignore
            const { Name, RecordId, Dimensions, ItemId } = props.data.product.result;
            const language = Dimensions?.filter((dimension: any) => {
                return dimension.DimensionTypeValue === 4;
            });
            const Style = Dimensions?.filter((dimension: any) => {
                return dimension.DimensionTypeValue === 1;
            });
            const Size = Dimensions?.filter((dimension: any) => {
                return dimension.DimensionTypeValue === 3;
            });

            const info = {
                sku: productNum[0].TextValue ? productNum[0].TextValue : RecordId,
                id: ItemId,
                name: Name,
                language: language && language[0] && language[0].DimensionValue ? language[0].DimensionValue.Value : '',
                style: Style && Style[0] && Style[0].DimensionValue ? Style[0].DimensionValue.Value : '',
                size: Size && Size[0] && Size[0].DimensionValue ? Size[0].DimensionValue.Value : ''
            };
            if (window && window['digitalData']) {
                window['digitalData'].push({
                    event: 'Product View',
                    product: [
                        {
                            info,
                            category: {
                                primary: category
                            }
                        }
                    ]
                });
            }
            setCurrentSku(productNum[0].TextValue);
            sessionStorage.setItem('productSku', productNum[0].TextValue);
        }
    }, [productSpec]);

    if (longDescription && longDescriptionValue && ArrayExtensions.hasElements(longDescription)) {
        drawerSummaries.push({
            // @ts-ignore
            title: props.resources.productDetailsLabel,
            content: (
                <Module {...ProductSpecification}>
                    <Node {...ProductSpecificationTableProps}>
                        {/* <Node {...ProductSpecificationTableBodyProps}>{longDescription}</Node> */}
                        <Node {...ProductSpecificationTableBodyProps}>
                            {' '}
                            <div dangerouslySetInnerHTML={{ __html: longDescriptionValue[0] }} />{' '}
                        </Node>
                    </Node>
                </Module>
            )
        });
    }

    if (productSpec && ArrayExtensions.hasElements(productSpec)) {
        drawerSummaries.push({
            // @ts-ignore
            title: props.resources.specificationsLabel,
            content: (
                <Module {...ProductSpecification}>
                    <Node {...ProductSpecificationTableProps}>
                        <Node {...ProductSpecificationTableBodyProps}>
                            <ProductSpecTable specs={productSpec} />
                        </Node>
                    </Node>
                </Module>
            )
        });
    }

    if (sizingChart && ArrayExtensions.hasElements(sizingChart)) {
        drawerSummaries.push({
            // @ts-ignore
            title: props.resources.sizingChartLabel,
            content: (
                <Module {...ProductSpecification}>
                    <Node {...ProductSpecificationTableProps}>
                        {/* <Node {...ProductSpecificationTableBodyProps}>{sizingChart}</Node> */}
                        {/* Sizing Chart Table */}
                        {/* <div {...ProductSpecificationTableBodyProps} dangerouslySetInnerHTML={{ __html: sizingChart[0] }} /> */}

                        {sizingChartCustom && (
                            <div
                                {...ProductSpecificationTableBodyProps}
                                //@ts-ignore
                                dangerouslySetInnerHTML={{ __html: sizingChartCustom.SizeChart }}
                            />
                        )}
                    </Node>
                </Module>
            )
        });
    }

    const [openIndex, setOpenIndex] = React.useState();

    const handleToggle = (event: any, index: any) => {
        if (event.target.open) {
            setOpenIndex(index);
        }
    };

    let productAuth;
    if (productSpecificationData) {
        productAuth = productSpecificationData.filter((attribute: any) => {
            return attribute.Name === 'Endowment' || attribute.Name === 'Temple' || attribute.Name === 'Recommend';
        });
    }
    let authRequired;
    if (productAuth) {
        authRequired = productAuth.map((attribute: any) => {
            return attribute.TextValue.includes('YES') ? true : false;
        });
    }

    const USE_VIEW_RESTRICTIONS = process.env.USE_VIEW_RESTRICTIONS;

    if (parseInt(USE_VIEW_RESTRICTIONS || '', 10) === 1 && authRequired.includes(true) && !props.context.request.user.isAuthenticated) {
        return <div>{''}</div>;
    } else {
        return drawerSummaries && ArrayExtensions.hasElements(drawerSummaries) ? (
            <>
                {drawerSummaries.map((summary, index) => (
                    <Drawer open={index === openIndex} onToggle={(event: any) => handleToggle(event, index)} key={index}>
                        <Summary>{summary.title}</Summary>
                        {summary.content}
                    </Drawer>
                ))}
            </>
        ) : null;
    }
};

export default ProductSpecificationView;
